import { render, staticRenderFns } from "./IDropdown.vue?vue&type=template&id=2d43cf2c&"
import script from "./IDropdown.vue?vue&type=script&lang=js&"
export * from "./IDropdown.vue?vue&type=script&lang=js&"
import style0 from "./IDropdown.vue?vue&type=style&index=0&id=2d43cf2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports